import { Component, EventEmitter, HostListener, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserHeaderDto } from 'src/app/data/models/dto/user-header.dto';
import { TicketStatus } from 'src/app/modules/tickets/enum/ticket-status.enum';
import { Ticket } from 'src/app/modules/tickets/models';
import { TicketsSharedService } from 'src/app/modules/tickets/services/tickets-shared.service';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss']
})

export class UserHeaderComponent implements OnDestroy {

  @Input() headerDto: UserHeaderDto | undefined

  @Output() onShowUserDetails = new EventEmitter<string | string[]>()

  @Input() idRoom?: string;

  ticket: Ticket | null = null;

  detailsText: string = 'Clique aqui para ver detalhes do contato'
  isMobile: boolean = false

  private subscription: Subscription | null = null;

  constructor(
    private readonly router: Router,
    private readonly ticketSharedService: TicketsSharedService,
  ) { }

  @HostListener('window:resize', ['$event'])
  getScreenSize() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 800) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  async ngOnInit() {
    this.getScreenSize();

    this.subscription = this.ticketSharedService.chatsDetailsTicketEvent$.subscribe((eventData) => {
      this.ticket = eventData;
    });
  }

  async ngOnDestroy() {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }

  getTicketStatus(style: boolean){
    if(!style){
      if(this.ticket?.status === TicketStatus.ON_GOING){
        return 'Em andamento';
      } 
      return 'Pendente de aprovação';
    }
    if(this.ticket?.status === TicketStatus.ON_GOING){
      return 'text-ticket-on-going';
    } 
    return 'text-ticket-pending-closure';
  }

  showUserDetails() {
    if (!this.isMobile) {

      if (!this.headerDto?.isRoom)
        this.onShowUserDetails.emit(this.headerDto?.id)
      else
        this.onShowUserDetails.emit(this.headerDto?.idsMembers)
    }
    else {
      this.router.navigate([`/user-details/${this.headerDto?.id}`]);
    }
  }

}
